import { animate, style, transition, trigger } from '@angular/animations';

export const entryHeightAnimation =
    trigger('entryHeight', [
        transition(':enter', [
            style({ height: 0, overflow: 'hidden', 'margin-bottom': 0, 'margin-top': 0 }),
            animate('250ms ease-in-out', style({ height: '*', 'margin-bottom': '*', 'margin-top': '*' }))
        ]),
        transition(':leave', [
            style({ overflow: 'hidden', 'margin-bottom': '*', 'margin-top': '*' }),
            animate('250ms ease-in-out', style({ height: 0, 'margin-bottom': 0, 'margin-top': 0 }))
        ])
    ]);
